export const DISPOSITION_LABEL = {
    replace_to_ro: 'Replace — RO warehouse',
    replace_to_ny: 'Replace — NY warehouse',
    deploy_support_kit: 'Deploy support kit',
    ask_user_diagnostic: 'Ask user diagnostic',
    escalate_engineering: 'Escalate to engineering',
    no_action: 'No action needed',
    unavailable: 'Diagnostics unavailable'
};
export const DISPOSITION_TAG_TYPE = {
    replace_to_ro: 'fail',
    replace_to_ny: 'fail',
    deploy_support_kit: 'warn',
    ask_user_diagnostic: 'warn',
    escalate_engineering: 'fail',
    no_action: 'success',
    unavailable: 'primary'
};
export const CONFIDENCE_LABEL = {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
};
export const CONFIDENCE_TAG_TYPE = {
    low: 'warn',
    medium: 'primary',
    high: 'fail'
};
// Safe accessors — fall back to a sensible display if the backend returns an
// enum value the FE doesn't recognise. Prevents undefined access on Tag/H.
export const titleCase = (raw) => raw
    .split('_')
    .map((word) => (word.length ? word[0].toUpperCase() + word.slice(1) : word))
    .join(' ');
// Human-readable label for a dispense `outcomes` key. Keys look like
// `success_clean`, `unknown`, or `pick_fail:plunge_count_max` (a "family:reason"
// pair). Render the family title-cased and the reason as a trailing clause.
export const getOutcomeLabel = (key) => {
    if (typeof key !== 'string' || !key)
        return 'Unknown';
    const [family, reason] = key.split(':');
    const familyLabel = titleCase(family);
    return reason ? `${familyLabel} — ${titleCase(reason)}` : familyLabel;
};
// Human-readable label for an evidence key (e.g. `popen_shift_test_passed`).
export const getEvidenceKeyLabel = (key) => typeof key === 'string' && key ? titleCase(key) : 'Unknown';
// Format an arbitrary evidence value for display: booleans → Yes/No, null →
// em-dash, numbers trimmed, objects/arrays as compact JSON.
export const formatEvidenceValue = (value) => {
    if (value === null || value === undefined)
        return '—';
    if (typeof value === 'boolean')
        return value ? 'Yes' : 'No';
    if (typeof value === 'number') {
        if (!Number.isFinite(value))
            return '—';
        return Number.isInteger(value) ? String(value) : value.toFixed(2);
    }
    if (typeof value === 'string')
        return value || '—';
    try {
        return JSON.stringify(value);
    }
    catch {
        return String(value);
    }
};
export const getDispositionLabel = (value) => {
    if (typeof value !== 'string' || !value)
        return 'Unknown';
    if (value in DISPOSITION_LABEL)
        return DISPOSITION_LABEL[value];
    return titleCase(value);
};
export const getDispositionTagType = (value) => {
    if (typeof value === 'string' && value in DISPOSITION_TAG_TYPE) {
        return DISPOSITION_TAG_TYPE[value];
    }
    return 'primary';
};
export const getConfidenceLabel = (value) => {
    if (typeof value !== 'string' || !value)
        return 'Unknown';
    if (value in CONFIDENCE_LABEL)
        return CONFIDENCE_LABEL[value];
    return titleCase(value);
};
export const getConfidenceTagType = (value) => {
    if (typeof value === 'string' && value in CONFIDENCE_TAG_TYPE) {
        return CONFIDENCE_TAG_TYPE[value];
    }
    return 'primary';
};
